import type { PulseKeyDto } from 'api/src/core/schemas/PulseKeySchema';
import ApiHttpClient from './ApiHttpClient';

export default class Licenses {
  constructor(private readonly client: ApiHttpClient) {}

  async unregisterMachine(key: string, machineId: string) {
    return this.client.post(`v1/provider/licenses/${key}/unregisterMachine`, {
      machineId,
    });
  }

  async updateLicense(key: string, license: PulseKeyDto['license']) {
    return this.client.put(`v1/provider/licenses/${key}`, license);
  }
}
